import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImportService {
  constructor() {}

  validateStringValue(
    value: any,
    allowNull: boolean = false,
    allowEmpty: boolean = false
  ): { isValid: boolean; value: any } {
    if (allowNull && (value === null || value === undefined)) {
      return {
        isValid: true,
        value: null
      };
    }
    if (allowEmpty && (value === null || value === undefined || (typeof value === 'string' && value.trim() === ''))) {
      return {
        isValid: true,
        value: value
      };
    }
    if (typeof value === 'string') {
      return {
        isValid: true,
        value: value
      };
    }
    return {
      isValid: false,
      value: value
    };
  }

  validateNumberValue(
    value: any,
    allowNull: boolean = false,
    allowEmpty: boolean = false
  ): { isValid: boolean; value: any } {
    if (allowNull && (value === null || value === undefined)) {
      return {
        isValid: true,
        value: null
      };
    }
    if (allowEmpty && (value === null || value === undefined || value === '')) {
      return {
        isValid: true,
        value: value
      };
    }
    if (typeof value === 'number') {
      return {
        isValid: true,
        value: value
      };
    }
    if (typeof value === 'string') {
      // Remove any whitespace
      const trimmedValue = value.trim();
      // Check if the string is a valid number
      if (!isNaN(Number(trimmedValue)) && trimmedValue !== '') {
        return {
          isValid: true,
          value: Number(trimmedValue)
        };
      }
    }
    return {
      isValid: false,
      value: value
    };
  }

  validateNumberOrString(
    value: any,
    allowNull: boolean = false,
    allowEmpty: boolean = false
  ): { isValid: boolean; value: any } {
    if (allowNull && (value === null || value === undefined)) {
      return {
        isValid: true,
        value: null
      };
    }
    if (allowEmpty && (value === null || value === undefined || (typeof value === 'string' && value.trim() === ''))) {
      return {
        isValid: true,
        value: value
      };
    }
    if (typeof value === 'number' || typeof value === 'string') {
      return {
        isValid: true,
        value: value
      };
    }
    return {
      isValid: false,
      value: value
    };
  }

  validateDateValue(
    value: any,
    allowNull: boolean = false,
    allowEmpty: boolean = false
  ): { isValid: boolean; value: any } {
    if (allowNull && (value === null || value === undefined)) {
      return { isValid: true, value: null };
    }
    if (allowEmpty && (value === null || value === undefined || (typeof value === 'string' && value.trim() === ''))) {
      return { isValid: true, value };
    }

    let date: Date;

    if (value instanceof Date) {
      date = value; // Directly use the Date object
    } else if (typeof value === 'string') {
      date = new Date(value);
    } else {
      return { isValid: false, value };
    }

    if (isNaN(date.getTime())) {
      return { isValid: false, value: `${value}` };
    }

    return { isValid: true, value: value };
  }

  validateCustomValues(
    value: any,
    allowedValues: any[],
    allowNull: boolean = false,
    allowEmpty: boolean = false
  ): { isValid: boolean; value: any } {
    if (allowNull && (value === null || value === undefined)) {
      return {
        isValid: true,
        value: null
      };
    }
    if (allowEmpty && (value === null || value === undefined || (typeof value === 'string' && value.trim() === ''))) {
      return {
        isValid: true,
        value: value
      };
    }
    if (allowedValues.find(allowedValue => allowedValue === value)) {
      return {
        isValid: true,
        value: value
      };
    }
    return {
      isValid: false,
      value: value
    };
  }

  validateEmailValue(
    value: any,
    allowNull: boolean = false,
    allowEmpty: boolean = false
  ): { isValid: boolean; value: any } {
    if (allowNull && (value === null || value === undefined)) {
      return {
        isValid: true,
        value: null
      };
    }
    if (allowEmpty && (value === null || value === undefined || (typeof value === 'string' && value.trim() === ''))) {
      return {
        isValid: true,
        value: value
      };
    }
    if (typeof value === 'string') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        return {
          isValid: false,
          value: `${value}`
        };
      }
      return {
        isValid: true,
        value: value
      };
    }
    return {
      isValid: false,
      value: value
    };
  }
  validatePhoneNumber(
    value: any,
    allowNull: boolean = false,
    allowEmpty: boolean = false
  ): { isValid: boolean; value: any } {
    if (allowNull && (value === null || value === undefined)) {
      return { isValid: true, value: null };
    }
    if (allowEmpty && (value === null || value === undefined || (typeof value === 'string' && value.trim() === ''))) {
      return { isValid: true, value };
    }
    if (typeof value === 'string') {
      const phoneRegex =
        /^(\+\s?)?((?<!\+.*)\(\+?\d+([\s\-\.]?\d+)?\)|\d+)([\s\-\.]?(\(\d+([\s\-\.]?\d+)?\)|\d+))*(\s?(x|ext\.?)\s?\d+)?$/;
      if (!phoneRegex.test(value)) {
        return { isValid: false, value: `${value}` };
      }
      return { isValid: true, value };
    }
    return { isValid: false, value };
  }
}
